var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 518,
    height: 337,
    viewBox: "0 0 518 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.359 187.403C99.3831 184.337 98.322 181.864 97.4784 180.076C96.4225 177.848 95.4251 175.768 93.6317 173.349C91.727 170.775 90.5703 169.21 88.3472 168.064C85.5033 166.6 82.7497 166.769 81.4975 166.865C79.0091 167.051 77.0354 167.99 73.088 169.868C71.0134 170.855 71.9313 170.568 67.0819 173.11C65.7024 173.831 64.2062 174.601 62.3969 175.991C60.4073 177.519 59.5955 178.612 59.5159 179.837C59.4735 180.448 59.6326 180.893 59.7547 181.281C60.1738 182.58 60.6461 184.528 60.8371 187.287",
    fill: "#F8EC30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507.839 188.126C507.393 180.39 508.04 174.219 508.741 169.927C509.765 163.661 510.905 161.422 509.643 158.032C507.748 152.97 502.374 150.407 497.572 148.121C492.203 145.563 490.871 146.354 484.419 143.255C482.647 142.406 479.437 140.756 475.771 138.21C468.035 132.84 468.178 130.357 463.34 128.659C459.7 127.381 456.506 127.694 452.166 128.118C446.329 128.686 441.958 130.447 440.27 131.179C436.572 132.792 436.832 133.381 431.983 135.684C427.632 137.748 425.451 138.783 422.432 139.287C416.723 140.242 413.768 138.475 411.98 140.549C410.728 142.003 411.917 143.176 410.717 145.595C409.083 148.885 406.022 148.45 403.332 151.362C401.905 152.906 401.337 155.718 400.27 161.274C399.634 164.584 398.902 168.436 398.53 173.885C398.286 177.44 398.169 181.966 398.53 187.219",
    fill: "#F8EC30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.533 187.164C372.111 183.392 372.265 180.622 372.695 178.755C373.103 176.977 373.655 176.5 374.499 173.587C375.141 171.359 375.73 169.337 375.698 167.098C375.656 163.787 374.281 161.416 372.212 157.85C370.005 154.041 369.623 154.715 367.166 150.645C364.524 146.263 364.63 144.92 362.243 142.358C360.232 140.198 358.168 139.015 357.197 138.511C356.008 137.895 352.342 136.054 347.705 136.468C344.713 136.734 344.914 137.62 339.656 138.75C336.436 139.445 334.78 139.784 332.568 139.471C331.899 139.376 330.886 139.179 325.962 137.068C322.131 135.423 321.585 135.046 320.317 134.548C315.876 132.802 311.753 133.211 309.143 133.465C302.251 134.144 301.184 136.723 289.984 140.373C285.198 141.933 282.8 142.713 280.795 142.718C280.312 142.718 278.969 142.692 277.372 143.26C277.372 143.26 275.749 143.838 274.311 145.064C272.199 146.862 271.616 164.843 273.229 189.393",
    fill: "#F8EC30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.371 186.321C246.705 182.108 246.27 179.286 246.01 176.23C245.357 168.494 246.705 169.311 245.83 166.679C243.994 161.167 239.314 161.273 234.656 153.346C233.642 151.622 233.94 151.744 232.491 149.202C229.525 143.982 228.04 141.371 225.286 139.472C221.482 136.851 217.253 136.798 215.194 136.771C211.762 136.729 210.86 137.546 207.087 138.034C202.211 138.66 198.492 137.96 194.115 137.132C185.62 135.53 183.487 133.216 178.436 134.07C175.253 134.606 171.948 135.874 171.948 135.874C169.719 136.729 169.523 137.058 167.623 137.859C165.342 138.814 161.145 140.575 156.46 140.023C153.171 139.636 149.748 138.554 147.764 141.992C143.668 149.086 143.344 160.504 143.477 168.494C143.769 186.024 143.212 186.114 144.018 187.414C147.955 193.776 160.493 190.391 178.256 189.398C213.226 187.446 243.84 196.147 246.01 189.398C246.164 188.916 246.233 188.056 246.371 186.337V186.321Z",
    fill: "#F8EC30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.8828 188.486C98.5326 187.351 97.9596 185.823 96.9887 184.162C94.999 180.756 92.5531 178.83 91.8527 178.304C90.3777 177.19 87.6347 175.126 83.7456 174.792C81.6286 174.612 79.7504 175.153 75.9992 176.235C73.0227 177.095 71.0066 177.975 69.2398 178.755C63.9553 181.095 63.1276 182.331 62.8411 182.809C61.6844 184.735 61.6685 187.016 61.6685 187.133C61.6685 187.993 61.8064 188.704 61.9391 189.208",
    fill: "#F8EC30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.4955 102.714H513.246V190.614H38.4955V102.714Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M503.696 189.027C505.018 182.708 505.023 177.472 504.779 173.89C504.45 169.094 504.169 165.629 501.717 162.536C499.791 160.117 497.383 158.986 493.791 157.671C482.187 153.41 473.067 152.444 473.067 152.444C461.962 151.267 462.54 152.869 451.085 151.903C437.571 150.768 435.194 148.407 430.18 150.821C424.509 153.553 426.228 157.214 418.285 161.995C414.491 164.281 409.653 166.117 406.57 168.844C406.262 169.12 404.533 170.67 402.065 172.627C401.052 173.429 400.643 173.72 400.442 173.89C398.951 175.126 397.969 178.506 400.261 187.945",
    fill: "#F8EC30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.246 187.944C370.859 184.946 370.042 180.696 368.185 175.873C366.736 172.128 365.564 169.077 363.139 166.323C360.003 162.763 356.942 162.153 347.1 158.757C332.546 153.733 334.658 153.473 328.721 152.088C319.866 150.024 312.873 150.061 308.718 150.104C303.084 150.167 299.545 150.236 295.024 151.727C291.825 152.783 292.509 153.107 285.654 155.871C281.824 157.415 280.014 157.961 278.088 159.834C275.998 161.866 275.16 164.111 274.666 165.421C271.387 174.154 274.576 188.342 275.027 190.289",
    fill: "#F8EC30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.395 187.043C243.71 184.586 242.691 181.62 241.153 178.394C240.723 177.498 239.142 174.245 236.107 169.926C231.183 162.917 228.721 159.416 224.572 158.211C222.678 157.665 220.667 157.665 216.646 157.67C211.876 157.675 211.6 158.27 209.44 157.85C205.095 157.012 205.217 154.434 200.431 152.624C196.739 151.229 193.258 151.478 189.799 151.722C188.398 151.823 186.583 152.147 182.949 152.805C174.847 154.264 175.123 154.603 173.038 154.609C167.276 154.625 166.278 152.057 162.946 153.165C160.989 153.818 161.54 154.635 156.277 160.015C153.598 162.758 152.744 163.268 148.892 167.22C146.992 169.173 146.037 170.149 145.65 170.643C144.154 172.547 141.75 177.307 145.65 189.022",
    fill: "#F8EC30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5295 65.5946V190.29H514.684V65.5946V0",
    stroke: "white",
    strokeWidth: 5.30572,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M514.684 115.686H484.775V102.714H398.642V115.686H368.007V102.714H273.226V115.686H241.869V102.714H142.402V115.686H114.654V102.714H37.5295",
    stroke: "white",
    strokeWidth: 5.30572,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M398.52 190.29V117.251",
    stroke: "white",
    strokeWidth: 5.30572,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M273.223 190.29V117.251",
    stroke: "white",
    strokeWidth: 5.30572,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.398 190.29V117.251",
    stroke: "white",
    strokeWidth: 5.30572,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M334.852 61.0898H105.103",
    stroke: "#F8EC30",
    strokeWidth: 2.65286,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M511.801 191.366H401.341",
    stroke: "#F8EC30",
    strokeWidth: 7.95858,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M375.094 191.366H276.105",
    stroke: "#F8EC30",
    strokeWidth: 7.95858,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M247.52 191.366H145.406",
    stroke: "#F8EC30",
    strokeWidth: 7.95858,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.766 191.366H59.6991",
    stroke: "#F8EC30",
    strokeWidth: 7.95858,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5273 192.942V335.656H-7.46263e-06",
    stroke: "#F8EC30",
    strokeWidth: 2.65286,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M117.718 84.5146H139.52V112.805H117.718V84.5146Z",
    fill: "#17375E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M244.755 84.5146H270.461V112.805H244.755V84.5146Z",
    fill: "#17375E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M370.705 84.5146H395.934V113.107H370.705V84.5146Z",
    fill: "#17375E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M486.572 84.5146H511.801V113.107H486.572V84.5146Z",
    fill: "#17375E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.774bd6b5886bc4dc2eea53bb6baf3050.svg";
export { ForwardRef as ReactComponent };